{
  "add_site": {
    "add_site": "Add site",
    "assign_company": "Assign site to company",
    "assign_existing_company": "Assign to existing company",
    "billing_address": "Company Address",
    "billing_address_optional": "Company Address (optional)",
    "choose_existing_company": "Choose existing company",
    "create_company": "Create new company",
    "errors": {
      "invalid": "There was an issue with validating the site. Please try again.",
      "required": "Field required"
    },
    "fields": {
      "address": {
        "city": {
          "label": "City"
        },
        "country": {
          "label": "Country"
        },
        "line1": {
          "label": "Address line 1",
          "placeholder": "Search address"
        },
        "line2": {
          "label": "Address line 2",
          "placeholder": "Apartment, landmark, etc."
        },
        "state": {
          "label": "State"
        },
        "zip": {
          "label": "Zip"
        }
      },
      "availability_config": {
        "label": "Availability"
      },
      "company": {
        "no_companies_found": "No Companies found",
        "required": "Company is required"
      },
      "ip_block": {
        "extra_cost": "Additional monthly costs apply.",
        "label": "IP Block"
      },
      "security_suite": {
        "label": "Edge Firewall",
        "unavailable_description": "Only available with Standard or Warm Spare Availability service"
      },
      "service_options": {
        "billing_warning": "Service options may impact your subscription billing."
      },
      "service_plan": {
        "label": "Service plan",
        "placeholder": "Select a Service Plan"
      },
      "service_tier": {
        "label": "Service tier",
        "placeholder": "Select a Service Tier"
      },
      "site_name": {
        "label": "Site Name"
      }
    },
    "go_to_site_config": "Go to Site Configuration",
    "provision_new_site": "Provision New Site",
    "shipping_information": {
      "ship_to_custom_address": "Ship to custom address",
      "ship_to_site_address": "Ship to site address"
    },
    "site_created": "Site {{name}} has been created",
    "title": {
      "address": "Site address",
      "assign_company": "Assign site to company",
      "details": "Site details",
      "service_options": "Service Options",
      "shipping_address": "Shipping information"
    }
  },
  "cards": {
    "circuits": "Circuits",
    "companies": "Companies",
    "sites": "Sites"
  },
  "drawer": {
    "title": "Sites"
  },
  "export_data": "Export as CSV",
  "header": {
    "company_settings": "Company Settings",
    "subtitle": "Here's a summary for your Bigleaf account",
    "title": "Hello {{name}}"
  },
  "logs": {
    "title": "Logs"
  },
  "order_site": {
    "order_new_site": "Order new site",
    "page_info": "Follow the steps to complete your site order. Please note that your order will incur an automatic charge 10 days after shipment. If you need any assistance or have questions while ordering a site, don’t hesitate to contact our <a>support</a> team. We’re here to help!",
    "wizard": {
      "accessories": {
        "antenna": {
          "label": "External 5G/LTE antenna",
          "options": {
            "5g_quad_13": "5G Remote Quad Antenna - 13m",
            "5g_quad_23": "5G Remote Quad Antenna - 23m",
            "5g_quad_8": "5G Remote Quad Antenna - 8m",
            "none": "None"
          }
        },
        "mounting_kit": {
          "label": "Router/CPE Mounting Kit",
          "options": {
            "none": "None",
            "rackmount_0": "Rackmount Kit (G17RM)",
            "wallmount_0": "Wallmount Kit (G17WM)"
          }
        },
        "step_name": "Accessories",
        "step_name_tooltip": "Accessories are available only for the Bigleaf Wireless Connect plan.",
        "title": "Accessories (optional)"
      },
      "back": "Back",
      "cancel": "Cancel Order",
      "donut": {
        "accessories": {
          "label": "Next: Shipping",
          "title": "Accessories"
        },
        "order_review": {
          "title": "Review"
        },
        "service_options": {
          "label": "Next: Add-Ons",
          "title": "Service Options"
        },
        "shipping": {
          "label": "Next: Review",
          "title": "Shipping"
        },
        "site_details": {
          "label": "Next: Service Options",
          "title": "Site Details"
        },
        "wireless_options": {
          "label": "Next: Accessories",
          "title": "Wireless Options"
        }
      },
      "next": "Next",
      "order_review": {
        "step_name": "Order Review"
      },
      "review": {
        "accessories": {
          "antenna": "External 5G/LTE antenna",
          "mounting": "Router/CPE Mounting Kit",
          "title": "Accessories:"
        },
        "button": "Review Site Order",
        "service_options": {
          "ip_block": "IP Block:",
          "service_plan": "Service plan:",
          "service_tier": "Service tier:"
        },
        "shipping": {
          "delivery_options": "Delivery options:",
          "priority": "Priority shipping (1-day)",
          "ship_to": "Ship to:",
          "standard": "Standard Shipping (3-days)"
        },
        "site_details": {
          "assigned_to": "Assigned to:",
          "site_address": "Site address:",
          "site_name": "Site name:"
        },
        "title": "Review your site order",
        "wireless_options": {
          "5g_lte": "5G/LTE:",
          "bwc": {
            "additional_circuit": "Additional circuit:",
            "carrier": "Carrier: ",
            "data": "Data package: ",
            "wireless_config": "Wireless Configuration: "
          }
        }
      },
      "service_options": {
        "ip_block": {
          "description": "This is a default IP block that comes with chosen Servide Tier. If you’d like to upgrade, <a>contact Bigleaf support</a>.",
          "title": "IP block"
        },
        "service_options": {
          "description": "Choose an SD-WAN service tier and plan that suits your needs. Every tier includes on-site Bigleaf router(s), access to our intelligent software linked to our proprietary Cloud Access network, and 24/7 Connect Care Support. For more details on pricing and service tiers, visit <a>our website</a>.",
          "fields": {
            "availability_config": {
              "label": "Availability",
              "placeholder": "Select an Availability"
            },
            "service_plan": {
              "label": "Service plan",
              "placeholder": "Select a Service Plan"
            },
            "service_tier": {
              "label": "Service tier",
              "placeholder": "Select a Service Tier"
            }
          },
          "title": "Service Options"
        },
        "step_name": "Service Options"
      },
      "shipping": {
        "shipping_address": {
          "options": {
            "company": {
              "description": "Company address:",
              "label": "Ship to company address"
            },
            "custom": {
              "description": "Custom address:",
              "fields": {
                "city": {
                  "label": "City"
                },
                "country": {
                  "label": "Country"
                },
                "line1": {
                  "label": "Address line 1"
                },
                "line2": {
                  "label": "Address line 2"
                },
                "state": {
                  "label": "State"
                },
                "zip": {
                  "label": "ZIP code"
                }
              },
              "label": "Ship to custom address"
            },
            "site": {
              "description": "Site address:",
              "label": "Ship to site address"
            }
          },
          "title": "Shipping information"
        },
        "shipping_delivery": {
          "options": {
            "priority": {
              "description": "Your order will be shipped within 1 day",
              "label": "Priority shipping"
            },
            "standard": {
              "description": "Your order will be shipped within approximately 3 days",
              "label": "Standard shipping"
            }
          },
          "title": "Delivery options"
        },
        "step_name": "Shipping"
      },
      "site_details": {
        "address": {
          "fields": {
            "city": {
              "label": "City"
            },
            "country": {
              "label": "Country"
            },
            "line1": {
              "label": "Address line 1"
            },
            "line2": {
              "label": "Address line 2"
            },
            "state": {
              "label": "State"
            },
            "zip": {
              "label": "ZIP code"
            }
          },
          "helper": "This is the physical location where Bigleaf service is being installed.",
          "title": "Site address"
        },
        "address_modal": {
          "cancel": "Save Without Validating",
          "city": "City",
          "country": "Country",
          "header": "Unable to validate address. Would you like to save without validating or use the suggested address below?",
          "line1": "Address line 1",
          "line2": "Address line 2",
          "state": "State",
          "submit": "Use Suggested Address",
          "zip": "ZIP code"
        },
        "company": {
          "create": {
            "fields": {
              "city": {
                "label": "City"
              },
              "country": {
                "label": "Country"
              },
              "line1": {
                "label": "Company address line 1"
              },
              "line2": {
                "label": "Company address line 2"
              },
              "name": {
                "label": "Company full name"
              },
              "state": {
                "label": "State"
              },
              "zip": {
                "label": "ZIP code"
              }
            },
            "title": "Create new company"
          },
          "existing": {
            "fields": {
              "company_id": {
                "label": "Choose Existing Company",
                "no_companies": "No Companies found"
              }
            },
            "title": "Assign to existing company"
          },
          "title": "Assign site to company"
        },
        "site_name": {
          "fields": {
            "site_name": {
              "label": "Site name",
              "required": "Site name is required"
            }
          },
          "title": "Site name"
        },
        "step_name": "Site Details",
        "suggested_modal_cancel": "Continue without validating"
      },
      "skip": "Skip This Step",
      "submit": "Submit Order",
      "success": {
        "body": "Order has been submitted to our Bigleaf provisioning team. We will process your order and ship any necessary equipment to your shipping address within 3-days. Please reach out to Bigleaf support (via help center) if you’d like to make any changes to this order.",
        "finish": "Got it",
        "order": "Order Another Site",
        "title": "Site order successfully submitted"
      },
      "wireless_options": {
        "bwc": {
          "add": "Additional Wireless Circuit",
          "circuit": {
            "carrier": {
              "label": "Carrier",
              "placeholder": "Select a Carrier"
            },
            "data_package": {
              "description": "Read more about wireless data plans <a>here</a>.",
              "label": "Data package",
              "placeholder": "Select a Data package",
              "select_label": "{{plan}} GB"
            },
            "wireless_config": {
              "integrated": "Integrated Modem (Recommended)",
              "label": "Wireless configuration",
              "placeholder": "Select a Wireless configuration",
              "standalone": "Standalone Modem"
            }
          },
          "description": "Maximize the advantages of our network optimization by integrating Bigleaf Wireless Connect into your site. This ideal combination guarantees exceptional connectivity for your business operations by incorporating 5G into any Bigleaf service plan. Additional costs apply. For more information, <a>visit our product page</a>.",
          "option": {
            "description": "Bigleaf managed 5G wireless service.",
            "title": "Bigleaf Wireless Connect"
          },
          "remove": "Remove Additional Circuit"
        },
        "lte_ready": {
          "description": "Integrate your certified 5G/LTE wireless carrier with Bigleaf for a seamless experience, complete with 24x7 Connect Care support. Approved carriers in the U.S. include Verizon, T-Mobile, and AT&T. Additional costs apply. For more information, <a>visit our product page</a>.",
          "option": {
            "description": "Customer brings their own certified carrier.",
            "title": "5G/LTE Ready",
            "tooltip": "The 5G/LTE Ready option is not available with your selected service tier and/or plan."
          }
        },
        "step_name": "Wireless Options",
        "title": "5G/LTE wireless service"
      }
    }
  },
  "status": {
    "circuit": {
      "degraded": "Degraded",
      "down": "Down",
      "normal": "Normal",
      "pending": "Pending",
      "provisioning": "Provisioning",
      "up": "Up"
    },
    "site": {
      "down": "Down",
      "healthy": "Healthy",
      "pending": "Pending",
      "provisioning": "Provisioning",
      "unhealthy": "Unhealthy"
    }
  },
  "tables": {
    "circuits": {
      "api_error": "There was an error loading circuits",
      "columns": {
        "bandwidth": "Bandwidth",
        "company_name": "Company",
        "data_used": "% Data Used",
        "name": "Circuit Name",
        "site_name": "Site",
        "status": "Status",
        "type": "Type",
        "usage": "Usage",
        "wan": "Circuit Port"
      },
      "download": {
        "button": "Export as CSV"
      },
      "filters": {
        "company_id": "Company",
        "path": "Sites > Circuits table",
        "site_id": "Site",
        "site_location": "Location",
        "status": "Status",
        "usage": "Usage"
      },
      "no_data": "No circuits available",
      "title": "Circuits"
    },
    "sites": {
      "api_error": "There was an error loading sites",
      "columns": {
        "all_issues": "Alerts",
        "circuits": "Circuits",
        "company_name": "Company",
        "devices": "Devices",
        "primary_pop": "Primary PoP",
        "primary_te": "Primary TE",
        "secondary_pop": "Secondary PoP",
        "service_plan": "Service Plan",
        "service_tier": "Service Tier",
        "site_location": "Site Location",
        "site_name": "Site",
        "status": "Status"
      },
      "download": {
        "button": "Export as CSV"
      },
      "drawer": {
        "issues": {
          "title": "Active Alerts"
        }
      },
      "filters": {
        "company_id": "Company",
        "path": "Sites > Sites table",
        "primary_pops": "Primary PoP",
        "primary_tes": "Primary TE",
        "service_plan": "Service Plan",
        "service_tier": "Service Tier",
        "site_id": "Site",
        "site_location": "Site Location",
        "status": "Status"
      },
      "no_data": "No Sites available",
      "title": "Sites"
    }
  },
  "tabs": {
    "circuits": "Circuits",
    "sites": "Sites"
  }
}
